import Vue from 'vue'

export type StatusBadgeType = 'alert' | 'warning' | 'notice'

export const {
  alertOrderStatusView,
  warningOrderStatusView,
  noticeOrderStatusView,
} = (() => {
  interface ColorCode {
    'background-color'?: string
    'color'?: string
    'font-weight'?: string
  }
  const baseView = (name: string, type: StatusBadgeType, colorCode: ColorCode = {}) => Vue.extend({
    name,
    template: `<component :is="tag" :data-type="type" :style="style"><slot></slot></component>`,
    data: () => ({
      type,
      style: colorCode,
    }),
    props: {
      tag: {
        type: String,
        default: 'div',
      },
    },
  })

  // `background-color` や `color` などのスタイル値が OrderListItem.vue 内のスタイル値と重複している
  // 本来は重複を排除する or そもそもここでスタイルを適用しないようにするべきだが、他コンポーネントにも影響するためいったん保留
  // SEE: https://github.com/Everforth/growthpalette-front/pull/8737#discussion_r2603064881
  return {
    alertOrderStatusView: baseView('AlertOrderStatusView', 'alert', { 'background-color': '#FDEFEF', color: '#DC5353', 'font-weight': '700' }),
    warningOrderStatusView: baseView('WarningOrderStatusView', 'warning', { 'background-color': '#F9F1E3', color: '#F4B030', 'font-weight': '700' }),
    noticeOrderStatusView: baseView('NoticeOrderStatusView', 'notice', { 'font-weight': '700' }),
  }
})()
